module.exports = __webpack_public_path__ + "img/14.7c8a4d2d.jpg";